import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsGithub } from "react-icons/bs";

const descriptionStyle = { textAlign: "justify" };
const buttonWrapperStyle = { textAlign: "center" };

function ProjectCards({ imgPath, title, description, ghLink }) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={descriptionStyle}>{description}</Card.Text>
        <div style={buttonWrapperStyle}>
          <Button variant="primary" href={ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {"GitHub"}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default React.memo(ProjectCards);
